{
  "app": {
    "update": {
      "message": "En oppdatering er tilgjenglig",
      "confirm": "Installer"
    },
    "offlineWarning": {
      "message": "Internett-tilkobling mistet",
      "description": "Du vil bli tatt til <strong>Offline</strong> modus. Du vil fremdeles ha tilgang til dine <strong>nedlastede</strong> arbeidsordre"
    },
    "offlineToolbar": {
      "info": "Offline Modus",
      "connected": "Tilkoblet internett",
      "disconnected": "Ingen nettverk tilgjenglig",
      "switchToOnline": "Bytt til online modus",
      "offlineChanges": "Offline endringer"
    },
    "storageWarning": {
      "message": "Du har lite tilgjenglig plass.<br />For å gjøre det mulig å laste ned flere arbeidsordre- fjern gamle eller ubrukte."
    }
  },
  "disclaimers": {
    "updateDownloaded": "Noen av dine nedlastede arbeidsordrer trenger å oppdateres"
  },
  "components": {
    "searchBar": {
      "ok": "Ok",
      "cancel": "Avbryt"
    },
    "emptyList": {
      "title": "Denne listen er tom",
      "info": "Ingen artikkler funnet"
    },
    "confirm": {
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    },
    "cableDialog": {
      "article": "Artikkel",
      "articleMissing": "Artikkel er ikke satt på arbeidslinjen og dialogen for kabeltrekking kunne ikke brukes.",
      "company": "Firma",
      "notSelected": "Ikke valgt",
      "editCompany": "Rediger firma",
      "loadingLocations": "Laster lokasjoner…",
      "location": "Lokasjon",
      "quantity": "(ANT: {{quantity}})",
      "locationRequired": "Lokasjon er påkrevd",
      "plannedLength": "Planlagt lengde",
      "pulledFromDrum": "Trukket fra trommel",
      "wholeNegative": "Verdien kan ikke være negativ",
      "wholeNotNumber": "Heltallsverdien godtar kun tall",
      "wholeRequired": "Feltet kan ikke være tomt",
      "decimalNegative": "Desimalverdien kan ikke være negativ",
      "decimalMax": "Desimalverdien kan ikke overstige 99",
      "decimalNotNumber": "Desimalverdien godtar kun tall",
      "asPlanned": "Som planlagt",
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    },
    "quantityDialog": {
      "allDone": "Alt ferdig",
      "cancel": "Avbryt",
      "confirm": "Bekreft",
      "done": "Ferdig",
      "total": "Total"
    },
    "putOnHoldInfoDialog": {
      "title": "Arbeidsordren er satt på vent",
      "description": "Satt på vent av ",
      "close": "Lukk"
    },
    "documentStatusDialog": {
      "title": "Sett dokumentstatus",
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    }
  },
  "header": {
    "workCenter": "Arbeidssenter",
    "project": "Prosjekt"
  },
  "profile": {
    "filterWorkCenters": "Finn arbeidssenter...",
    "filterProjects": "Finn prosjekt...",
    "selectCompanyStepTitle": "Velg firma per prosjekt",
    "selectCompanyStepDescription": "Firma kreves for å bruke lagerplasseringen som brukes av kabeltrekking. Du kan hoppe over dette hvis du ikke bruker denne funksjonen.",
    "loadingCompanies": "Laster firmaer...",
    "company": "Firma",
    "noCompaniesForProject": "Ingen firmaer tilgjengelig for dette prosjektet.",
    "roles": {
      "FOREMAN": "Formann",
      "OPERATOR": "Operatør"
    },
    "continue": "Fortsett",
    "done": "Ferdig",
    "back": "Tilbake",
    "removeFromSelection": "Fjern fra utvalg: ",
    "removeSiteConfirm": "Fjern denne lokasjonen fra utvalget ditt?",
    "removeWorkCenterConfirm": "Fjern dette arbeidssenteret fra utvalget ditt?",
    "removeProjectConfirm": "Fjern dette prosjektet fra utvalget ditt?",
    "workOrderDateInfo": "Kun arbeidsordrer med planlagt startdato innenfor de neste 180 dagene vil vises.",
    "workCenterReplacementInfo": "EPUE-koder vil bli erstattet med nye arbeidssenter (Q%). Vær oppmerksom på at prosjektet ditt fortsatt kan bruke EPUE inntil utskiftingen er fullført."
  },
  "workOrderComments": {
    "title": "Notater",
    "add": {
      "confirm": "Legg til",
      "cancel": "Avbryt"
    },
    "edit": {
      "editNote": "Rediger kommentar",
      "deleteNote": "Slett kommentar",
      "saveNote": "Lagre",
      "changePhoto": "Endre bilde",
      "changeVideo": "Endre video"
    },
    "delete": {
      "deleteNoteBy": "Slett notat av"
    },
    "replies": {
      "replyAction": "Svar",
      "reply": "svar",
      "replies": "svar",
      "show": "· Vis",
      "hide": "· Skjul",
      "placeholder": "Skriv et svar… (Enter for å sende, Shift+Enter for ny linje)",
      "send": "Send",
      "cancel": "Avbryt"
    },
    "referenceType": {
      "WORK_ORDER": "Arbeidsordre",
      "WORK_LINE": "Arbeidslinje",
      "MATERIAL": "Material",
      "EQUIPMENT": "Utstyr",
      "OBJECT": "Objekt",
      "DOCUMENT": "Dokument",
      "MIPS_CONSTRUCTION": "Construction-kommentar",
      "MIPS_ENGINEERING": "Engineering-kommentar",
      "MIPS_MATERIAL": "Material-kommentar"
    },
    "list": {
      "addNote": "Legg til notat",
      "workOrderNote": null
    },
    "empty": {
      "title": "Siden er tom",
      "info": "Du kan starte å legge til notater med “lag notat” knappen."
    }
  },
  "workOrderFeedback": {
    "title": "Jobbtilbakemelding",
    "summary": {
      "workOrder": "Arbeidsordre",
      "title": "Tittel",
      "platform": "Lokasjon",
      "taskNo": "Task No",
      "date": "Dato"
    },
    "prompt": {
      "title": "Hvordan gikk jobben?",
      "info": "Velg en status. Ved negativ eller nøytral tilbakemelding må du skrive en kort kommentar slik at jobbkortet kan forbedres."
    },
    "sentiment": {
      "NOT_GOOD": "Ikke bra",
      "NEUTRAL": "OK, men trenger forbedring",
      "GOOD": "Bra"
    },
    "topicsTitle": "Hva gjelder tilbakemeldingen?",
    "commentLabel": "Kommentar",
    "commentPlaceholder": "Beskriv kort hva som fungerte / ikke fungerte.",
    "impactLabel": "Potensiell påvirkning",
    "impact": {
      "NONE": "Ingen",
      "SCHEDULE_PROGRESS": "Fremdrift / plan",
      "COST": "Kostnad",
      "HMS": "HMS",
      "QUALITY": "Kvalitet",
      "UNSURE": "Usikker"
    },
    "performedByLabel": "Utført av",
    "improvementLabel": "Foreslått forbedring",
    "improvementPlaceholder": "Hva bør endres før neste gjennomføring?",
    "submit": "Send tilbakemelding",
    "submitting": "Sender...",
    "submitSuccess": "Tilbakemelding sendt.",
    "submitQueuedOffline": "Tilbakemeldingen er lagret offline og synkroniseres når forbindelsen er tilbake.",
    "submitError": "Kunne ikke sende tilbakemelding. Prøv igjen.",
    "recipientWarning": "Ingen mottaker-epost for tilbakemelding er konfigurert for dette prosjektet.",
    "noRecipientConfirm": {
      "title": "Ingen mottaker-epost konfigurert",
      "description": "Dette prosjektet mangler mottaker-epost for tilbakemelding. Tilbakemeldingen kan lagres, men ingen e-post blir sendt.",
      "saveAnyway": "Lagre likevel"
    },
    "resend": "Send på nytt",
    "resending": "Sender på nytt...",
    "resendSuccess": "Tilbakemelding sendt på nytt.",
    "resendError": "Kunne ikke sende tilbakemelding på nytt. Prøv igjen.",
    "previousTitle": "Dine tidligere tilbakemeldinger",
    "empty": {
      "title": "Ingen tilbakemeldinger ennå",
      "info": "Innsendte tilbakemeldinger vises her."
    },
    "validation": {
      "sentimentRequired": "Velg en status.",
      "commentRequired": "Kommentar er påkrevd for valgt status.",
      "potentialImpactRequired": "Velg minst én potensiell påvirkning."
    }
  },
  "workOrderDetails": {
    "assignTo": "Tildel",
    "claim": null,
    "description": "Beskrivelse",
    "equipment": {
      "customerId": null,
      "description": "Beskrivelse",
      "equipment": "Utstyr",
      "functionalLocation": null,
      "materialNo": "Materiale no.",
      "serialNo": null,
      "storageLocation": null
    },
    "hoursTable": {
      "header": {
        "description": "Beskrivelse",
        "hours": "Timer"
      },
      "row": {
        "estimate_hours": "Estimerte timer",
        "hours_remaining": "Gjenstående timer",
        "hours_earned_this_week": "Tjente timer denne uken"
      }
    },
    "estimatedHours": "Est. Timer",
    "finish": "Slutt",
    "madeBy": "Opprettet av",
    "releaseToAll": "Tilgjengelig for alle",
    "remainingHours": "Tid igjen",
    "start": "Start",
    "usedHours": "Tid brukt",
    "wbs": "WBS",
    "statusName": "Status",
    "precedingWorkOrder": "Foregående arbeidsordre",
    "succeedingWorkOrder": "Etterfølgende arbeidsordre",
    "relatedWorkOrders": "Relaterte arbeidsordre",
    "putOnHold": "Sett arbeidsordren på vent",
    "releaseWorkOrder": "Igangsett arbeidsordren",
    "confirmPutOnHoldTitle": "Sett Arbeidsordre:",
    "confirmPutOnHoldDescription": "{{ workOrderNumber }} på vent?",
    "confirmReleaseOnHoldDescription": "{{ workOrderNumber }}?",
    "operators": {
      "empty": {
        "info": "Ingen operatører funnet"
      }
    }
  },
  "workOrderDocuments": {
    "jobPackage": "Job",
    "attachment": "Att",
    "video": "Video",
    "timeDrawing": "Doc",
    "timeDrawings": "Time Drawings",
    "revision": "Revisjon",
    "unauthorized": "Du har ikke tilgang til dette dokumentet",
    "loadFailed": "Dokumentet kunne ikke lastes",
    "notAvailableOffline": "Dokumentet er ikke lastet ned for bruk uten nett",
    "empty": {
      "title": "Siden er tom",
      "info": "Ingen dokumenter finnes i denne arbeidsordren enda."
    },
    "notSupported": "Hvis nettleseren ikke kan vise dokumentet, klikk her for å laste det ned.",
    "status": {
      "redlineMarkup": "Redline Markup",
      "forInfo": "Til info",
      "noChange": "Ingen endring",
      "label": "Status: {{id}} ({{name}})",
      "notSetLabel": "Status: ikke satt"
    }
  },
  "offlineDownload": {
    "title": "Last ned for bruk uten nett",
    "options": {
      "files": "Filer:",
      "allFiles": "Alle filer",
      "jobPackage": "Jobbpakke",
      "attachments": "Vedlegg",
      "docs": "Dokumenter",
      "model3d": "3D-filer",
      "videos": "Videoer"
    },
    "badges": {
      "model3d": "3D",
      "video": "Video"
    },
    "metadata": "Metadata",
    "total": "Valgt: {{count}} dokumenter, {{size}}",
    "unknownSize": "(+ {{count}} med ukjent størrelse)",
    "progress": {
      "running": "{{done}}/{{total}} lastet ned, nedlastingen vil fortsette i bakgrunnen om du lukker dialogen.",
      "done": "Nedlasting ferdig, du kan lukke dialogen.",
      "doneWithFailures": "Nedlasting ferdig, men {{failed}} av {{total}} dokumenter feilet. Du kan lukke dialogen.",
      "failed": "Nedlastingen feilet. Sjekk tilkoblingen og prøv igjen."
    },
    "noDocuments": "Arbeidsordren har ingen dokumenter.",
    "loadFailed": "Dokumentlisten kunne ikke lastes.",
    "offline": "Du er frakoblet. Koble til nettet for å laste ned.",
    "status": {
      "queued": "Venter",
      "downloading": "Laster ned",
      "done": "Lastet ned",
      "failed": "Feilet"
    },
    "close": "Lukk",
    "download": "Last ned"
  },
  "workOrderLines": {
    "backTo": "Tilbake til",
    "confirmWarning": "Denne arbeidslinjen har bare {{quantity}} av {{plannedQuantity}} registrert",
    "confirmComplete": "Er du sikker på at du vil fullføre og lukke arbeidslinjen?",
    "confirmReOpenWarning": "Er du sikker på at du vil gjenåpne arbeidslinjen:",
    "cableCompanyIdMissing": "Firma-ID er ikke satt for dette prosjektet. Sett firma-ID i innstillinger for å laste lagerlokasjoner.",
    "cableArticleMissing": "Artikkel mangler for dette omfanget. Rapportering må gjøres i MIPS.",
    "cableNoLocationsFound": "Ingen lokasjoner funnet for det valgte firmaet. Kontroller at du har valgt riktig firma, eller kontakt din supervisor hvis du mistenker at lagerlokasjonene i MIPS ikke er oppdatert.",
    "cablePulledLengthExceedsAvailable": "Uttrukket lengde er lengre enn tilgjengelig på valgt lokasjon/trommel, vennligst velg en annen lokasjon/trommel.",
    "continueTo": "Fortsett til",
    "end": "Slutt",
    "installedQuantity": "Installert Qty.",
    "lineComplete": "Fullfør",
    "lineDescription": "Beskrivelse",
    "lineId": "ID",
    "lineNo": "Linje",
    "plannedQuantity": "Planlagt Qty.",
    "start": "Start",
    "work": "Tid",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "workOrderList": {
    "filters": {
      "open": "Alle",
      "closed": "Arkiv",
      "released": "Tilgjengelige",
      "unreleased": "Utilgjengelige",
      "assigned": "Mine",
      "downloaded": "Nedlastet",
      "dueThisWeek": "Frist denne uken",
      "overDue": "Forsinket"
    },
    "estimatedHours": "Est. Timer",
    "finish": "Slutt",
    "searchLabel": "Søk",
    "show": "Vis",
    "sortActHoursAsc": "Brukte timer (lav til høy)",
    "sortActHoursDesc": "Brukte timer (høy til lav)",
    "sortEstFinishDateAsc": "Slutt Dato (første til siste)",
    "sortEstFinishDateDesc": "Slutt Dato (siste til første)",
    "sortEstHoursAsc": "Estimerte timer (lav til høy)",
    "sortEstHoursDesc": "Estimerte timer (høy til lav)",
    "sortEstStartDateAsc": "Start Dato (første til siste)",
    "sortEstStartDateDesc": "Start Dato (siste til første)",
    "sortWorkOrderNumberAsc": "Alfabetisk (A to Å)",
    "sortWorkOrderNumberDesc": "Alfabetisk (Å to A)",
    "sortLabel": "Sorter",
    "start": "Start",
    "empty": {
      "info": "Ingen arbeidsordre funnet"
    }
  },
  "workOrderMaterials": {
    "material": "Materialer",
    "articleNumber": "Artikkel nr.",
    "available": "Ja",
    "description": "Beskrivelse",
    "quantity": "Antall",
    "status": "Tilgjengelig",
    "materialStatus": "Materialstatus",
    "unavailable": "Nei",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen materialer"
    },
    "location": "Sted"
  },
  "weightReport": {
    "title": "Vektendring / tilleggsarbeid",
    "sending": "Sender…",
    "cancel": "Avbryt",
    "duplicate": "Dupliser",
    "sendSuccess": "Vektskjema sendt",
    "sendError": "Kunne ikke sende vektskjemaet. Prøv igjen.",
    "lineSaveError": "Kunne ikke lagre linjen. Prøv igjen.",
    "lineDeleteError": "Kunne ikke slette linjen. Prøv igjen.",
    "send": {
      "action": "Send {{count}} linje(r)",
      "offlineHint": "Du må være tilkoblet for å sende skjemaet.",
      "pendingHint": "Venter på at offline-endringer synkroniseres før skjemaet kan sendes."
    },
    "status": {
      "draft": "Ikke sendt",
      "sent": "Sendt"
    },
    "currentSchema": {
      "title": "Gjeldende skjema",
      "empty": "Ingen linjer lagt til ennå"
    },
    "line": {
      "add": "Legg til linje",
      "addTitle": "Ny linje",
      "editTitle": "Rediger linje",
      "edit": "Rediger",
      "delete": "Slett",
      "save": "Lagre linje",
      "saving": "Lagrer…",
      "tag": "Tag / beskrivelse",
      "quantity": "Stk / meter",
      "descriptionColumn": "Materiell / arbeidsoperasjon",
      "status": "Status"
    },
    "jobCard": {
      "title": "Jobbkortinformasjon",
      "workOrderNumber": "Arbeidsordrenummer",
      "jobTitle": "Tittel",
      "platform": "Plattform",
      "performedBy": "Utført av / navn"
    },
    "registration": {
      "mainCategory": "Hovedkategori",
      "hours": "Timer brukt",
      "predefinedOptions": "Forhåndsdefinerte valg – velg alt som passer"
    },
    "category": {
      "ADDITIONAL_WORK": "Tilleggsarbeid",
      "WEIGHT_CHANGE": "Vektendring",
      "OTHER": "Annet"
    },
    "weight": {
      "installed": "Montert vekt",
      "removed": "Demontert vekt",
      "total": "Total vekt",
      "followUp": "Krever endringen oppfølging?",
      "followUpYes": "Ja",
      "followUpNo": "Nei",
      "description": "Beskrivelse av materiale / arbeid",
      "descriptionPlaceholder": "Beskriv kort hva som ble gjort, hvorfor det var tilleggsarbeid, og eventuell påvirkning på timer, vekt eller fremdrift."
    },
    "documentation": {
      "recipient": "Delt postkasse / mottaker",
      "recipientHint": "Konfigurert per prosjekt",
      "comment": "Kommentar til leder / integrasjonsansvarlig",
      "commentPlaceholder": "Eventuell tilleggskommentar eller behov for avklaring.",
      "attachments": "Vedlegg",
      "downloadAttachment": "Last ned",
      "attachmentsLoading": "Laster vedlegg...",
      "attachmentsPendingHint": "Disse filene lastes opp når linjen lagres.",
      "attachmentsOfflineHint": "Vedlegg krever internettforbindelse.",
      "noAttachments": "Ingen vedlegg",
      "attachmentLoadError": "Kunne ikke laste vedlegg.",
      "attachmentUploadError": "Kunne ikke laste opp ett eller flere vedlegg.",
      "attachmentDownloadError": "Kunne ikke laste ned vedlegget."
    },
    "details": {
      "sentAt": "E-post sendt",
      "notSent": "Ikke sendt"
    },
    "history": {
      "title": "Sendte skjemaer for denne arbeidsordren",
      "empty": "Ingen skjemaer sendt ennå",
      "lineCount": "{{count}} linje(r)"
    }
  },
  "workOrderObjectHierarchy": {
    "workLines": "Arbeidslinjer",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    },
    "selectStatus": "Status"
  },
  "workOrderOperations": {
    "backTo": null,
    "continueTo": null,
    "end": null,
    "installedQuantity": null,
    "lineComplete": null,
    "lineDescription": null,
    "lineId": null,
    "lineNo": null,
    "plannedQuantity": null,
    "start": null,
    "workCenter": null,
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "workOrderTimer": {
    "confirm": {
      "cancel": null,
      "confirm": null,
      "discard": null,
      "info": null,
      "reportOn": null,
      "selectOperation": null
    },
    "estimatedHours": null
  },
  "workOrderObject": {
    "selectAll": "Velg alle",
    "objectNumber": "Objekt nr.",
    "description": "Beskrivelse",
    "progressType": "Type",
    "progress": "Fremdrift",
    "completionSystem": "Ferdigstillingssystem",
    "select": "Velge",
    "apply": "Utfør",
    "checklistLink": "Digital Sjekkliste"
  },
  "workOrderObjectList": {
    "from": "Fra",
    "to": "Til",
    "cableRouteHeader": "Kabel ruter",
    "documents": "Dokumenter",
    "currentObject": "Nåværende",
    "fromObject": "Fra",
    "toObject": "Til",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "pushNotification": {
    "WO_ADD_COMMENT": {
      "WORK_ORDER": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on your current work order: "
        }
      },
      "DEFAULT": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on {{ referenceType }}: ",
          "onWorkOrder": ". On your current work order: "
        }
      }
    },
    "WO_PUT_ON_HOLD": {
      "header": "Work order put on hold",
      "body": {
        "prefix": "Work order: ",
        "suffix": ", has been put on hold by: "
      }
    },
    "WO_RELEASE_PUT_ON_HOLD": {
      "body": {
        "prefix": "User: ",
        "suffix": ", just reactivated the work order: "
      }
    },
    "WO_UPDATE_OBJ_PROGRESS": {
      "header": "Object progress was updated",
      "body": {
        "prefix": "User: ",
        "suffix": ", has updated progress on the work lines. On your current work order: "
      }
    },
    "WO_UPDATE_INSTALLED_QUANTITY_ON_WORK_LINE": {
      "header": "Object installed quantity was updated",
      "body": {
        "user": "User: ",
        "updated_quantity": ", has updated installed quantity on the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_COMPLETE": {
      "body": {
        "user": "User: ",
        "just_completed": ", just completed the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_OPEN": {
      "body": {
        "user": "User: ",
        "just_completed": ", has started the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_DOCUMENT_PROCESSED": {
      "header": "Updated Documentation",
      "body": {
        "document": "Document no: ",
        "on_work_order": ", on work order: "
      }
    },
    "DEFAULT": {
      "header": "Action was taken",
      "body": "User: {{triggeredByName}} has made a change in {{referenceName}}:{{referenceType}} in {{sourceId}} with an event: {{eventType}}"
    }
  },
  "error": {
    "page": {
      "400": {
        "title": "Invalid web address",
        "description": "Did you type this address directly? Check for typos. Did you copy and paste the address? Check that you included the entire address.",
        "button": "Return to home base"
      },
      "403": {
        "title": "Key missing...",
        "description": "Looks like you don't have the necessary permissions to view this page.",
        "button": "Get on board"
      },
      "404": {
        "title": "Looks like the page is lost at sea",
        "description": "The page you're trying to find has disappeared or no longer exists.",
        "button": "Return to home base"
      },
      "500": {
        "title": "An unexpected error occurred",
        "description": "It's not you, it's us. We have been notified of the incident. Please try again later",
        "button": "Return to home base"
      }
    },
    "dialog": {
      "internal_server_error": {
        "title": "Intern server feil.",
        "description": "Prøv igjen senere, eller kontakt support.",
        "button": "OK"
      },
      "general_error": {
        "title": "Noe gikk galt.",
        "description": "Hvis problemet oppstår ijen, prøv å laste siden på ny eller kontakt support",
        "button": "OK"
      },
      "no_connection": {
        "title": "Kunne ikke laste innhold!",
        "description": "Ingen forbindelse til serveren.",
        "button": "Prøv på nytt"
      }
    }
  },
  "versionCheck": {
    "newVersionAvailable": "Ny versjon {{version}} er tilgjengelig!",
    "viewReleaseNotes": "Se utgivelsesnotater"
  }
}
